import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import Input from 'components/common/Input';
import IconButton from 'components/common/IconButton';
import StarRating from 'components/common/StarRating';
import { useProductRating } from 'hooks/useProductHook';

const defaultValues = {
 rating: 0,
 text: '',
 author: { name: '', email: '' }
};

const RatingForm = ({ rating, product }) => {
 const { methods, handleSubmit, onSubmit, onError } = useProductRating({ product });

 const { watch, reset, register, setValue, formState } = methods;
 const { errors } = formState;

 useEffect(() => {
  if (rating?.code) reset({ ...defaultValues, ...rating });
 }, [rating]);

 return (
  <>
   <h5 className="mb-3">Deja tu reseña</h5>
   <div className="mb-3">
    <Form.Label className="mb-0">Clasificación:</Form.Label>
    <StarRating className="d-block fs-3" rating={watch('rating')} handleChange={ratng => setValue('rating', ratng)} />
   </div>

   <Input
    type="text"
    name="author.name"
    label="Nombre:"
    errors={errors}
    placeholder="Nombre"
    formGroupProps={{ className: 'mb-3' }}
    formControlProps={{ ...register('author.name'), autoComplete: 'off' }}
   />

   <Input
    type="email"
    name="author.email"
    label="Email:"
    errors={errors}
    placeholder="Email"
    formGroupProps={{ className: 'mb-3' }}
    formControlProps={{ ...register('author.email'), autoComplete: 'off' }}
   />

   <Input
    type="textarea"
    errors={errors}
    label="Reseña:"
    name="text"
    placeholder="Escribe tu reseña"
    formGroupProps={{ className: 'mb-3' }}
    formControlProps={{ ...register('text'), autoComplete: 'off', rows: 3 }}
   />

   <IconButton
    size="sm"
    icon="plus"
    transform="shrink-3"
    variant="falcon-success"
    className="float-end"
    onClick={() => handleSubmit(onSubmit, onError)()}
   >
    Enviar
   </IconButton>
  </>
 );
};

RatingForm.propTypes = { rating: PropTypes.object, product: PropTypes.string };

RatingForm.defaultProps = { rating: {}, product: '' };

export default RatingForm;
